import { Offer } from './offer.model';
import { PricingOption } from './pricing-option.model';
import { OfferVehicleView } from './offer-vehicle.model';
import { InsuranceItem } from './insurance-item.model';

export class OfferViewDTO extends Offer {
  public pricingOptions?: PricingOption[] = [];
  public deletable?: boolean;
  public minQuantity?: number;
  public maxQuantity?: number;
  public handlingTypes?: string[] = [];
  public offerVehicles?: OfferVehicleView[];
  public insuranceItems?: InsuranceItem[] = [];

  constructor(data: any = {}) {
    super(data);
    this.deletable = data.deletable;
    this.minQuantity = data.minQuantity;
    this.maxQuantity = data.maxQuantity;
    this.handlingTypes = data.handlingTypes;
    this.pricingOptions = (data.pricingOptions || []).map((val: any) => new PricingOption(val));
    this.offerVehicles = (data.offerVehicles || []).map((val: any) => new OfferVehicleView(val));
    this.insuranceItems = (data.insuranceItems || []).map((val: any) => new InsuranceItem(val));
  }

  override serialize(): any {
    const baseSerialization = super.serialize();
    return {
      ...baseSerialization,
      deletable: this.deletable,
      minQuantity: this.minQuantity,
      maxQuantity: this.maxQuantity,
      handlingTypes: this.handlingTypes,
      pricingOptions: (this.pricingOptions || []).map(val => val.serialize()),
      offerVehicles: (this.offerVehicles || []).map(val => val.serialize()),
      insuranceItems: (this.insuranceItems || []).map(val => val.serialize()),
    };
  }
}
